import React from 'react';
import { Modal, ModalCloseButton } from '@thebouqs/ui';
import {
  DotwModalProps,
  DotwModalData,
  DotwData,
  DotwTriggerProps,
} from './Dotw.d';
import { Heading, Button, Text } from '@thebouqs/ui';
import useTranslation from '@/hooks/useTranslation';
import { getDotw } from '@/lib/content';
import { dotwTrackingObjFactory } from './dotwTracking';
import useAnalytics from '@/hooks/useAnalytics';
import useUser from '@/hooks/useUser';

export const DotwErrorFallbackComponent = ({
  open,
  setOpenDotwModal,
}: Partial<DotwModalProps>): JSX.Element => {
  const { t } = useTranslation();
  return (
    <>
      <Modal
        data-testid="error-reporting-dotw-modal"
        label={t('dotw.button')}
        open={open}
        size="sm"
        CloseButton={
          <ModalCloseButton label="close-modal" variant="normal" size="sm" />
        }
        callback={() => setOpenDotwModal(false)}>
        <Heading as="h3" size="sm" textAlign="center">
          {t('common.errors.errorBoundaryMsg.title')}
        </Heading>
        <Text marginTop="md" textAlign="center">
          {t('common.errors.errorBoundaryMsg.body')}
        </Text>
      </Modal>
    </>
  );
};

export const DotwTrigger = ({
  isLoading = true,
  setOpenDotwModal,
  display,
  dotwData,
}: DotwTriggerProps): JSX.Element => {
  const { t } = useTranslation();
  const { track } = useAnalytics();
  const dotwCta = dotwData?.dotwCta;
  const { is_subscriber: isSubscriber } = useUser();

  if (!isLoading && !display) {
    return null;
  }

  const dotwTriggerClick = () => {
    const segmentPropsObj = dotwTrackingObjFactory({
      ...dotwData,
      label: dotwCta,
      is_subscriber: isSubscriber || false,
    });
    track('Deal of the Week Button Clicked', segmentPropsObj);
    setOpenDotwModal(true);
  };

  return (
    <Button
      isLoading={isLoading}
      colorScheme="green"
      size="sm"
      variant="solid"
      borderRadius="sm"
      width="full"
      minWidth={isLoading ? 36 : null}
      //TODO: remove typography styles once Bouqs UI button styles are updated
      textTransform="none"
      aria-label={t('aria.label.openName', { name: dotwCta })}
      onClick={dotwTriggerClick}>
      {dotwCta}
    </Button>
  );
};

export const fetchDotw = async (): Promise<DotwModalData> => {
  const res: DotwData = await getDotw();

  return res;
};
